import { SyntheticEvent } from 'react';

import { twMerge } from 'tailwind-merge';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { getRegionUrl, getSpeciesGroupRegionUrl } from '@domain/routes/urls';
import { EventMykissCardClicked } from '@generated/events';
import { ChevronRightIcon } from '../../Icons/ChevronRightIcon';
import { Text } from '../../Text/Text';
import { LinkCard } from '../LinkCard/LinkCard';

interface IProps {
  testId?: string;
  countryId: string;
  countryName: string;
  stateId: string;
  stateName: string;
  /* An identifier for where this carousel is being used, e.g. species-top-waters */
  clickEventSource: EventMykissCardClicked['properties']['source'];
  /* An ID of the resource type where this carousel is being used, e.g. a species ID if it's on a species page */
  clickEventSourceId?: EventMykissCardClicked['properties']['source_id'];
  /* The position of the card in a list (if applicable) */
  clickEventPosition?: EventMykissCardClicked['properties']['position'];
  className?: string;
  isDisabled?: boolean;
  useCustomLoader?: boolean;
  onClick?: (event: SyntheticEvent) => void;
  speciesGroupSEOId?: string;
  rank: number;
}

export const TopStateLinkCard = ({
  testId,
  countryId,
  countryName,
  stateId,
  stateName,
  clickEventSource,
  clickEventPosition,
  clickEventSourceId,
  className = '',
  isDisabled = false,
  onClick,
  speciesGroupSEOId,
  rank,
}: IProps) => {
  const { currentPage } = useAnalytics();
  const url = speciesGroupSEOId
    ? getSpeciesGroupRegionUrl(countryId, stateId, speciesGroupSEOId)
    : getRegionUrl(countryId, stateId, countryName, stateName);
  return (
    <LinkCard
      onClick={onClick}
      to={url}
      withDefaults={false}
      disabled={isDisabled}
      data-testid={testId}
      eventProperties={{
        source: clickEventSource,
        target: speciesGroupSEOId ? `speciesgroup_region` : 'region',
        target_id: speciesGroupSEOId ?? stateId,
        position: clickEventPosition,
        source_id: clickEventSourceId,
        page: currentPage,
      }}
      className={twMerge('border-b-twilight relative w-full border-b py-2.5', className)}
    >
      <div className="relative flex items-center gap-4">
        <Text as="div" variant="sm" className="m-0 font-semibold">
          {rank}
        </Text>
        <div className="flex grow flex-col">
          <Text as="div" variant="sm" className="m-0 font-semibold">
            {stateName}
          </Text>
        </div>
        <div className="text-abyss mr-1.5">
          <ChevronRightIcon />
        </div>
      </div>
    </LinkCard>
  );
};
